import * as React from "react";
import { Col, Form, Row } from "react-bootstrap";
import Phone from "../form/Phone";
import Email from "../form/Email";
import FirstName from "../form/FirstName";
import LastName from "../form/LastName";
import { config } from '_config';

export default function RenewalStep3({ state, onChange, onBlur, validated }) {

  const handleChange = (e) => {
    onChange(e);
  };

  return (
    <Form id="TrademarkForm" noValidate validated={validated}>
      <div className="question">
        {config.skin === 'v2-basic' && <h2>Your Account</h2>}
        <div className="polaroid">
        <p className="primary-label">Please provide us with the contact information for the person submitting this order.</p>
        <div className="one-column-form">
          <FirstName id="firstName" label="Your First Name" value={state.firstName} onChange={handleChange} />
          <LastName id="lastName" label="Your Last Name" value={state.lastName} onChange={handleChange} />
          <Phone id="phone" label="Phone Number" state={state} onChange={handleChange} />
          <Email id="email" label="Email Address" state={state} onChange={handleChange} onBlur={onBlur} />
        </div>
        </div>
      </div>
    </Form>
  );
}
